import { render, staticRenderFns } from "./AccidentReviewIndex.vue?vue&type=template&id=4d6fc04e&scoped=true&"
import script from "./AccidentReviewIndex.vue?vue&type=script&lang=js&"
export * from "./AccidentReviewIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6fc04e",
  null
  
)

export default component.exports